import { render, staticRenderFns } from "./AddTimestamps.vue?vue&type=template&id=2dc8a358&scoped=true"
import script from "./AddTimestamps.vue?vue&type=script&lang=js"
export * from "./AddTimestamps.vue?vue&type=script&lang=js"
import style0 from "./AddTimestamps.vue?vue&type=style&index=0&id=2dc8a358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8a358",
  null
  
)

export default component.exports